import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {httpValidateAccesses, HttpValidateAccessesOptions} from '../http/accesses.http'
import {MUTATION_KEYS} from '@/queryClient'

export const useValidateAccesses = (
    options?: Omit<UseMutationOptions<unknown, AxiosError, HttpValidateAccessesOptions['payload']>, 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.VALIDATE_ACCESS],
        mutationFn: payload => httpValidateAccesses({payload})
    })
}
